const viewportWidth = () => {
  const calculateWidths = () => {
    document.documentElement.style.setProperty(
      '--scrollbar-width',
      `${window.innerWidth - document.body.clientWidth}px`,
    );
    document.documentElement.style.setProperty(
      '--viewport-width',
      `${document.body.clientWidth}px`,
    );
  };
  let animationFrame;
  window.addEventListener('resize', () => {
    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
    }
    animationFrame = requestAnimationFrame(calculateWidths);
  });

  calculateWidths();
};

viewportWidth();
